import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, LazyModule, type LazyComponent } from 'owa-bundling';
import { SuggestionsPlaceholder } from 'owa-copilot-dab/lib/components/SuggestionsPlaceholder';
import type { CopilotDabEntrypoint } from 'owa-copilot-telemetry/lib/types/scenarios/CopilotDabTypes';
import type { MailboxInfo } from 'owa-client-types';
import type { ComposeViewState } from 'owa-mail-compose-store';
import type { MailSuggestionContext } from './utils/getSuggestions';

export type { MailSuggestionContext } from './utils/getSuggestions';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "CopilotDabMail" */ './lazyIndex'),
    { name: 'CopilotDabMail' }
);

export const LazyCopilotDabMailSuggestions: LazyComponent<
    {
        getEntrypoint: () => CopilotDabEntrypoint;
        mailboxInfo: MailboxInfo;
        targetWindow?: Window;
        context?: MailSuggestionContext;
        composeViewState?: ComposeViewState;
    },
    undefined,
    null
> = createLazyComponent(lazyModule, m => m.CopilotDabMailSuggestions, SuggestionsPlaceholder);
